export function parseMark(value) {
  if (value == null) return null;
  const t = String(value).trim();
  if (!t || t === '--' || t === '-' || t === '—') return null;
  if (!/^\d+(\.\d+)?$/.test(t)) return null;
  return Number(t);
}

function hasMarks(row, keys) {
  return keys.some((k) => parseMark(row?.[k]) != null);
}

/**
 * Poster/subject chip for optional electives.
 * Matric: Bio vs Comp.
 * Intermediate: Phy/Stats × Chem/Comp × Math/Bio combinations.
 */
export function optionalSubjectLabel(row) {
  const hasBio = hasMarks(row, ['bio', 'bio2', 'pr_biology']);
  const hasComp = hasMarks(row, ['comp', 'comp2', 'pr_computer']);
  const hasPhy = hasMarks(row, ['phy', 'phy2', 'pr_physics']);
  const hasStat = hasMarks(row, ['stat', 'stat2', 'pr_statistics']);
  const hasChem = hasMarks(row, ['chem', 'chem2', 'pr_chemistry']);
  const hasMath = hasMarks(row, ['math', 'math2']);

  const isIntermediate = /inter|hssc/i.test(String(row?.level || ''));
  if (isIntermediate) {
    const parts = [];
    if (hasPhy && !hasStat) parts.push('Phy');
    else if (hasStat && !hasPhy) parts.push('Stat');
    else if (hasPhy) parts.push('Phy');
    if (hasChem && !hasComp) parts.push('Chem');
    else if (hasComp && !hasChem) parts.push('Comp');
    else if (hasChem && hasComp) parts.push('Chem');
    if (hasMath && !hasBio) parts.push('Math');
    else if (hasBio && !hasMath) parts.push('Bio');
    else if (hasBio) parts.push('Bio');
    return parts.join(' · ');
  }

  if (hasBio && !hasComp) return 'Bio';
  if (hasComp && !hasBio) return 'Comp';
  if (hasBio) return 'Bio';
  if (hasComp) return 'Comp';
  return '';
}
